<script>
  import { urlServeur } from "../components/conf.js";
  import VueListeDetailEmploye from "../components/VueListeDetailEmploye.svelte";
  import Spinner from "../components/ToolsSpinner.svelte";

  let rows;
  let searchTerm = "";
  let parti = false;
  //=============  Methodes ==============

  /**
   * creation des params pour l'url
   */
  const recupParamsUrl = () => {
    let url = "";

    if (searchTerm !== "") {
      url += "nom=" + searchTerm;
    }
    if (parti) {
      url += "parti=1";
    }

    if (url !== "") {
      url = "?" + url;
    }

    return url;
  };

  /**
   * Affichae HTML de la liste Hist_salaries
   * @param id
   */
  let displayInfo = (id) => {
    //alert("id = " + id);
    const element = document.getElementById(
      "TAB_EMP_" + recupParamsUrl(params)
    );
    if (element.style.visibility === "hidden") {
      element.style.visibility = "visible";
    } else {
      element.style.visibility = "hidden";
    }
  };

  /**
   *  recherche des datas sur le serveur
   * api_employe/employes?id=xxx&nom=nom_personne&parti=0|1
   */
  const fetchData = async (q) => {
    const response = await fetch(
      urlServeur + "/api_employe/employes" + recupParamsUrl()
    );
    if (response.ok) {
      const result = await response.json();

      rows = result.payload;
      return rows;
    } else {
      throw new (Error(text))();
    }
  };

  let promise = fetchData();

  /***
   *
   */
  const chercher = async (q) => {
    promise = fetchData();
    searchTerm = "";
  };
</script>

<!-- moteur recherche  -->
<div class="row">
  <nav class="navbar bg-light">
    <div class="container-fluid">
      <form class="d-flex" role="search">
        <input
          bind:value={searchTerm}
          class="form-control me-2"
          type="search"
          placeholder="nom/poste"
          aria-label="Search"
        />
        <button
          on:click={() => chercher()}
          class="btn btn-outline-success"
          type="submit">Search</button
        >
      </form>
    </div>
  </nav>
</div>

<!--  ********   data  ************ -->
{#await promise}
  <Spinner />
{:then elements}
  <VueListeDetailEmploye {elements} />
{:catch error}
  <p style="color: red">{error.message}</p>
{/await}

<style>
</style>
